import POST from "./api/POST";
import GET from "./api/GET";
import PATCH from "./api/PATCH";
import PUT from "./api/PUT";

export const getOrderDetails = async (id) => {
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/details/${id}`,
  );
  return response;
};
export const getOrderRawData = async (id) => {
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/raw-data/${id}`,
  );
  return response;
};
export const orderData = async (id) => {
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/data/${id}`,
  );
  return response;
};
export const createNewOrder = async (credentials) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch",
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/create`,
    { ...credentials, branchId: branchId },
  );
  return response;
};

export const getPreferredDriverOptions = async (branchId) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch",
  );
  const resolvedBranchId = branchId ?? JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/preferred-drivers?branchId=${resolvedBranchId}`,
  );
  return response;
};

export const switchOrderDriver = async (orderId, driverId) => {
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/switch-driver/${orderId}`,
    { driverId },
  );
  return response;
};

export const editOrder = async (credentials) => {
  const response = await PUT(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/update/${credentials?._id}`,
    { ...credentials },
  );
  return response;
};

export const pendingOrders = async (page = 1, limit = 10) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch",
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/pending?branchId=${branchId}&page=${page}&limit=${limit}`,
  );
  return response;
};

export const driverOrders = async (page = 1, limit = 10) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch",
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/driver?branchId=${branchId}&page=${page}&limit=${limit}`,
  );
  return response;
};

export const enRouteOrders = async (page = 1, limit = 10) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch",
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/en-route?branchId=${branchId}&page=${page}&limit=${limit}`,
  );
  return response;
};

export const completedOrders = async (page = 1, limit = 10) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch",
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/completed?branchId=${branchId}&page=${page}&limit=${limit}`,
  );
  return response;
};

export const scheduledOrders = async (page = 1, limit = 10) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch",
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/scheduled?branchId=${branchId}&page=${page}&limit=${limit}`,
  );
  return response;
};

export const failedOrders = async (page = 1, limit = 10) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch",
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/failed?branchId=${branchId}&page=${page}&limit=${limit}`,
  );
  return response;
};

export const countOrders = async () => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch",
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/count?branchId=${branchId}`,
  );
  return response;
};

export const cancelOrder = async (id) => {
  const response = await PATCH(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/cancel/${id}`,
    {},
  );
  return response;
};

export const archieveOrder = async (id) => {
  const response = await PATCH(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/archieve/${id}`,
    {},
  );
  return response;
};

export const currentOrders = async (branch) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch",
  );
  const branchId = branch?._id ?? JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/current-orders?branchId=${branchId}`,
  );
  return response;
};

export const currentOrder = async (branch, driverId) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch",
  );
  const branchId = branch?._id ?? JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/current-order?branchId=${branchId}&driverId=${driverId}`,
  );
  return response;
};

export const orderHistory = async (page, limit, startDate, endDate, search) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch",
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/order-history?branchId=${branchId}&page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&search=${search}`,
  );
  return response;
};

export const exportOrderHistory = async (credentials) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch",
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/export-order-history`,
    {
      ...credentials,
      branchId: branchId,
    },
    {
      responseType: "blob",
    },
  );
  return response;
};
